const trans = (key, parameters = {}) => window.Translator.trans(key, parameters);

export default trans
